import React, { useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function SocialProof() {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const reviews = [{
    name: 'Deborah M.',
    age: 62,
    rating: 5,
    title: 'Finally found something that works!',
    comment: "I've tried everything for my knees over the years. These patches are the first thing that actually stays put through my water aerobics class. The gentle warmth is so soothing, and I can feel it working within about 15 minutes. I'm ordering more for my husband to try on his shoulder.",
    image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Carol J.',
    age: 54,
    rating: 5,
    title: 'Great for long shifts',
    comment: "As a nurse, I'm on my feet for 12+ hours. These patches have been a game-changer for me. They're discreet under my scrubs, stay on all day, and provide consistent comfort. The fact that they don't have a strong medicinal smell is a huge plus in a hospital setting.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9GT1efdpcuUWg76K2tLyh3/33a807aa-8374-4b7a-9359-1840fdbd1385.png'
  }, {
    name: 'Susan T.',
    age: 59,
    rating: 4,
    title: 'Good for gardening days',
    comment: 'I garden a lot and my knees used to protest after an hour or so of kneeling and getting up. These patches have made a big difference. They stay on surprisingly well despite all the movement. The only reason for 4 stars instead of 5 is I wish they were slightly larger to cover more area.',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  const testimonialImages = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1L2zrWNoW6rH96v8MUSDhD/52f4ca86-f373-4d49-abca-ed6b777bd8c0_%281%29.png',
    caption: 'Perfect fit for active knees - stays on through movement',
    alt: 'Person applying a green MyoQuell patch to their knee'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3F2opyYJBmsJaEaqihyAqJ/fc21d8a4-0898-4fc2-9717-28e8bd5731fd.png',
    caption: "Herbal comfort that's easy to apply",
    alt: 'MyoQuell herbal knee patch with packaging showing 8-hour wear time'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6BBMmKf5zot3rgeDmktk7t/6e56b577-4be8-4f15-983d-5a9693475482.png',
    caption: 'Contoured design for maximum coverage',
    alt: 'Person holding a green MyoQuell patch over their knee while sitting'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bBVHXroqH6gjXJP6yGVAGQ/IMG_8498.png',
    caption: 'Works for both knees simultaneously',
    alt: 'Person with MyoQuell patches applied to both knees'
  }];
  const nextImage = () => {
    setActiveImageIndex(prevIndex => prevIndex === testimonialImages.length - 1 ? 0 : prevIndex + 1);
  };
  const prevImage = () => {
    setActiveImageIndex(prevIndex => prevIndex === 0 ? testimonialImages.length - 1 : prevIndex - 1);
  };
  return <section id="reviews" className="py-12 bg-[#EAF7F3]" data-id="element-340">
      <div className="container mx-auto px-4" data-id="element-341">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-342">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#0E6B6B] mb-4 md:mb-0" data-id="element-343">
            What Our Customers Say
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-344">
          {reviews.map((review, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-345">
              <div className="flex items-center mb-4" data-id="element-346">
                <img src={review.image} alt={`${review.name}'s profile`} className="w-12 h-12 rounded-full object-cover mr-4" loading="lazy" data-id="element-347" />
                <div data-id="element-348">
                  <div className="font-bold" data-id="element-349">
                    {review.name}, {review.age}
                  </div>
                  <div className="text-amber-400" data-id="element-350">
                    {'★'.repeat(review.rating)}
                    {'☆'.repeat(5 - review.rating)}
                  </div>
                </div>
              </div>
              <h3 className="font-bold mb-2" data-id="element-351">{review.title}</h3>
              <p className="text-gray-700" data-id="element-352">{review.comment}</p>
            </div>)}
        </div>
        {/* Real-world usage testimonial images */}
        <div className="mb-8" data-id="element-353">
          <h3 className="text-xl font-serif font-bold text-center mb-6 text-[#1A3C2A]" data-id="element-354">
            See MyoQuell In Action
          </h3>
          {/* Mobile carousel */}
          <div className="md:hidden relative" data-id="element-355">
            <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-356">
              <div className="relative pb-4" data-id="element-357">
                <img src={testimonialImages[activeImageIndex].image} alt={testimonialImages[activeImageIndex].alt} className="w-full h-64 object-contain rounded-lg" loading="lazy" data-id="element-358" />
                <p className="text-center font-medium mt-4" data-id="element-359">
                  {testimonialImages[activeImageIndex].caption}
                </p>
              </div>
              {/* Navigation dots */}
              <div className="flex justify-center mt-2" data-id="element-360">
                {testimonialImages.map((_, index) => <button key={index} onClick={() => setActiveImageIndex(index)} className={`h-2 w-2 rounded-full mx-1 ${activeImageIndex === index ? 'bg-[#0E6B6B]' : 'bg-gray-300'}`} aria-label={`Go to image ${index + 1}`} data-id="element-361" />)}
              </div>
              {/* Navigation buttons */}
              <button onClick={prevImage} className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md" aria-label="Previous image" data-id="element-362">
                <ChevronLeftIcon size={20} className="text-[#0E6B6B]" data-id="element-363" />
              </button>
              <button onClick={nextImage} className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md" aria-label="Next image" data-id="element-364">
                <ChevronRightIcon size={20} className="text-[#0E6B6B]" data-id="element-365" />
              </button>
            </div>
          </div>
          {/* Desktop grid */}
          <div className="hidden md:grid md:grid-cols-4 gap-4" data-id="element-366">
            {testimonialImages.map((item, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-sm" data-id="element-367">
                <img src={item.image} alt={item.alt} className="w-full h-48 object-contain rounded-lg mb-3" loading="lazy" data-id="element-368" />
                <p className="text-center font-medium" data-id="element-369">{item.caption}</p>
              </div>)}
          </div>
        </div>
        <div className="text-center" data-id="element-370">
          <a href="#faq" className="inline-block py-3 px-6 bg-[#0E6B6B] text-white font-medium rounded-full hover:bg-[#095959] transition-colors" data-id="element-371">
            Common Questions
          </a>
        </div>
      </div>
    </section>;
}